export default __webpack_public_path__ + "static/media/lofi-icons.0174b97c.jpg";